import prefersColorScheme, {
  colorSchemes,
} from '@magica11y/prefers-color-scheme'
import type { ColorScheme } from '@magica11y/prefers-color-scheme'

/**
 * Checks if the user prefers dark color scheme.
 * Uses the @magica11y/prefers-color-scheme library to respect user preferences.
 *
 * @returns true if the user prefers dark color scheme, false otherwise
 */
export function checkPrefersDarkMode(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  const colorSchemePreference = prefersColorScheme()
  return colorSchemePreference === colorSchemes.DARK
}

/**
 * Checks if the user prefers light color scheme.
 * Uses the @magica11y/prefers-color-scheme library to respect user preferences.
 *
 * @returns true if the user prefers light color scheme, false otherwise
 */
export function checkPrefersLightMode(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  const colorSchemePreference = prefersColorScheme()
  return colorSchemePreference === colorSchemes.LIGHT
}

/**
 * Gets the user's preferred color scheme.
 * Uses the @magica11y/prefers-color-scheme library to detect user preferences.
 *
 * @returns 'light' | 'dark' | null - The preferred color scheme, or null if preference cannot be determined
 */
export function getColorScheme(): ColorScheme {
  if (typeof window === 'undefined') {
    return null
  }

  const colorSchemePreference = prefersColorScheme()
  if (colorSchemePreference === colorSchemes.DARK) {
    return 'dark'
  }
  if (colorSchemePreference === colorSchemes.LIGHT) {
    return 'light'
  }
  return null
}
